import React, {FC, ReactElement} from 'react';

import {Plural} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemIcon} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemIcon';
import {DropdownItemMultiline} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemMultiline';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {TooltipOverflowCondition} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipOverflowCondition';
import {RecipientGroupMatchModel} from '../../../../models/api/recipientMatchModel';

/*
 * Props.
 */

interface RecipientGroupDropdownItemProps extends DropdownItemProps {
  group: RecipientGroupMatchModel;
}

/*
 * Component.
 */

export const RecipientGroupDropdownItem: FC<RecipientGroupDropdownItemProps> = (props) => (
  <DropdownItem {...props}>
    <DropdownItemIcon iconName="list" label={null} />
    <DropdownItemMultiline
      title={
        <TooltipCoordinator render={() => props.group.name}>
          <TooltipOverflowCondition>{props.group.name}</TooltipOverflowCondition>
        </TooltipCoordinator>
      }
      subtitle={renderContactsCount(props.group.contactsCount)}
    />
  </DropdownItem>
);

function renderContactsCount(count: number = 0): ReactElement {
  return <Plural id="recipients-dropdown-group-count" value={count} one="# contact" other="# contacts" />;
}
